import { render, staticRenderFns } from "./activity-workshop-enroll.vue?vue&type=template&id=40281e16&scoped=true&"
import script from "./activity-workshop-enroll.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-enroll.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-enroll.vue?vue&type=style&index=0&id=40281e16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40281e16",
  null
  
)

export default component.exports